import React from "react";

export default function Expense({ config, i, modal, remove, renderField, renderSelect }) {
    const removeExpense = () =>
        modal({
            name: "confirm",
            title: "Удаление расхода",
            text: "Вы уверены, что хотите удалить расход?",
            buttons: { confirm: "Удалить", cancel: "Отменить" },
            action: () => remove(i),
        });

    return (
        <div className="mb-3">
            <div className="book-form__section-head book-form__section-head--closable">
                <button
                    type="button"
                    className="book-form__section-close close border-0 bg-transparent p-0"
                    onClick={removeExpense}
                    title="Удалить расход"
                    aria-label="Удалить расход"
                />
                <div className="pl-3">
                    <strong>#{i + 1} Расход</strong>
                </div>
            </div>
            {renderSelect({ ...config.typeId, fieldWrapper: "col-sm-8 col-md-5" })}
            {renderField({ ...config.value, fieldWrapper: "col-sm-8 col-md-5" })}
            {renderField({ ...config.comment, fieldWrapper: "col-sm-8 col-md-5" })}
        </div>
    );
}
